import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, memo, useCallback, useRef, useState } from 'react';
import { BasicNvlWrapper } from '../basic-wrapper/BasicNvlWrapper';
import { INTERACTIVE_WRAPPER_ID } from '../utils/constants';
import { InteractionHandlers } from './InteractionHandlers';
const options = {
    selectOnClick: false,
    drawShadowOnHover: true,
    selectOnRelease: false,
    excludeNodeMargin: true
};
/**
 * The interactive React wrapper component contains a collection of interaction handlers by default
 * and provides a variety of common functionality and callbacks.
 * It is an extension of the {@link BasicNvlWrapper} component and incorporates the
 * @neo4j-nvl/interaction-handlers module's decorators to provide a set of interaction events.
 *
 * The mouseEventCallbacks property takes an object where various callbacks can be defined
 * and behavior can be toggled on and off.
 *
 * For examples, head to the {@link https://neo4j.com/docs/nvl/current/react-wrappers/#_interactive_reactive_wrapperr Interactive React wrapper documentation page}.
 */
export const InteractiveNvlWrapper = memo(forwardRef(({ nodes, rels, layout, layoutOptions, onInitializationError, mouseEventCallbacks = {}, nvlCallbacks = {}, nvlOptions = {}, interactionOptions = options, ...nvlEvents }, nvlRef) => {
    const newNvlRef = useRef(null);
    const myNvlRef = nvlRef ?? newNvlRef;
    const [isNvlInitialized, setIsNvlInitialized] = useState(false);
    const handleInitialization = useCallback(() => {
        setIsNvlInitialized(true);
    }, []);
    const handleInitializationError = useCallback((error) => {
        setIsNvlInitialized(false);
        if (onInitializationError) {
            onInitializationError(error);
        }
    }, [onInitializationError]);
    const setupInteractions = isNvlInitialized && myNvlRef.current !== null;
    return (_jsxs(_Fragment, { children: [_jsx(BasicNvlWrapper, { ref: myNvlRef, nodes: nodes, id: INTERACTIVE_WRAPPER_ID, rels: rels, nvlOptions: nvlOptions, nvlCallbacks: {
                    ...nvlCallbacks,
                    onInitialization: () => {
                        if (nvlCallbacks.onInitialization !== undefined) {
                            nvlCallbacks.onInitialization();
                        }
                        handleInitialization();
                    }
                }, layout: layout, layoutOptions: layoutOptions, onInitializationError: handleInitializationError, ...nvlEvents }), setupInteractions && (_jsx(InteractionHandlers, { nvlRef: myNvlRef, mouseEventCallbacks: mouseEventCallbacks, interactionOptions: interactionOptions }))] }));
}));
